import React from 'react';
import './DestinationCard.css';

const DestinationCard = ({ image, title }) => {
  return (
    <div className="destination-card">
      <img src={image} alt={title} />
      <h3>{title}</h3>
    </div>
  );
};

export default DestinationCard;
